import { render, staticRenderFns } from "./CorrelationDiagram.vue?vue&type=template&id=9f86b488&scoped=true"
import script from "./CorrelationDiagram.vue?vue&type=script&lang=ts"
export * from "./CorrelationDiagram.vue?vue&type=script&lang=ts"
import style0 from "./CorrelationDiagram.vue?vue&type=style&index=0&id=9f86b488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f86b488",
  null
  
)

export default component.exports